<script>
    import { scale } from 'svelte/transition';
    export let value = '';
    export let placeholder = '';
</script>

<div class="flex-inline w-full">
    <input class="mb-2 bg-gray-200 appearance-none rounded w-full py-2 px-4 text-gray-700 focus:outline-none focus:bg-white focus:border-gray-300 shadow-lg"
        placeholder="{placeholder}"
        transition:scale
        type="text"
        bind:value />
</div>
